import { render, staticRenderFns } from "./NotificationEvent.vue?vue&type=template&id=2926ac28&scoped=true&"
import script from "./NotificationEvent.vue?vue&type=script&lang=ts&"
export * from "./NotificationEvent.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationEvent.vue?vue&type=style&index=0&id=2926ac28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2926ac28",
  null
  
)

export default component.exports